import styled from "styled-components";

export const StyledButton = styled.button`
  background-color: ${(props) =>
    props.isActive ? "#1890ff" : "#fff"} !important;
  color: ${(props) => (props.isActive ? "white" : "black")} !important;
  border-color: #eee;
  height: 32px;
  padding: 0 15px;
  font-size: 14px;
  line-height: 30px;
  background: #fff;
  border: ${(props) =>
    props.isActive ? "0px" : "1px solid #d9d9d9"} !important;
  border-radius: ${(props) => props.borderRadius || "4px"};
  border-top-width: 1.02px;
  border-left-width: 0;
  cursor: pointer;
  transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;
  &:hover {
    background-color: ${(props) =>
      props.isActive ? "#1890ffcc" : "#fff"} !important;
    color: ${(props) => (props.isActive ? "white" : "#1890ff")} !important;
  }
`;

export const StyledDarkerButton = styled.button`
  background-color: #0066b5 !important;
  color: white !important;
  &:hover {
    background-color: #1890ff !important;
  }

  border-color: #eee;
  height: 32px;
  margin-right: 4px;
  padding: 0 15px;
  font-size: 14px;
  line-height: 30px;
  background: #fff;
  border: ${(props) =>
    props.isActive ? "0px" : "1px solid #d9d9d9"} !important;
  border-radius: 4px;
  border-top-width: 1.02px;
  border-left-width: 0;
  cursor: pointer;
  transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;
`;

export const StyledDisabledButton = styled.button`
  color: rgba(0, 0, 0, 0.25) !important;
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9;
  text-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  cursor: not-allowed;
  height: 32px;
  margin-right: 4px;
  padding: 0 15px;
  font-size: 14px;
  line-height: 30px;
  background: #fff;
  border: 1px solid #d9d9d9 !important;
  border-radius: 4px;
  border-top-width: 1.02px;
  border-left-width: 0;
`;

export const StyledPlainButton = styled.button`
  background-color: transparent;
  border: 0px;
  cursor: pointer;
`;

export const WidgetButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: default;
  outline: none;
  text-decoration: none;
  &:focus {
    outline: 2px solid #1550f5;
    outline-offset: 2px;
  }
`;
